// Result.js
import React, { useContext, useState } from "react";
import "../../styles/Report.css";
import { ToastContainer } from "react-toastify";
import { MdUpload } from "react-icons/md";
import SurveyContext from "../../context/surveyContext";
import PageHeading from "../PageHeading";

// NEW imports
import SurveyUploadForm from "./SurveyAnalytics/SurveyUploadForm";
import SurveyAnalyticsList from "./SurveyAnalytics/SurveyAnalyticsList";

const Result = () => {
  const surveyContext = useContext(SurveyContext);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenModal = () => {
    surveyContext.updateOpenModal(true);
  };

  const handleCloseModal = () => {
    surveyContext.updateOpenModal(false);
  };

  const handleSurveyCreated = () => {
    // trigger a refresh in SurveyAnalyticsList
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="gms-page-section report-tabs">
      <ToastContainer />

      <div className="gms-wrapper">
        <PageHeading
          pageTitle="Survey Analytics"
          icon={<MdUpload />}
          pageModalTitle="Upload New Survey"
          pageModalOpen={handleOpenModal}
        />

        <SurveyUploadForm
          isOpen={surveyContext.isOpenModal}
          onClose={handleCloseModal}
          onCreated={handleSurveyCreated}
        />

        <SurveyAnalyticsList refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default Result;
